import { Component, HostListener, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { IxellAPIService, TchatService } from 'src/app/tools/api.service';
import { HeaderService } from 'src/app/tools/header.service';
import { ErrorService } from '../../../tools/error.service';
import { StorageService } from '../../../tools/storage.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-tchat-assistance',
  templateUrl: './tchat-assistance.component.html',
  styleUrls: ['./tchat-assistance.component.scss']
})
export class TchatAssistanceComponent implements OnInit {

  private langue: string;
  private langueSub: any;
  language: string;
  urlTchat: string;
  urlSafe: SafeResourceUrl;
  initialTitle = "IxellWebLab";
  processTitle: any = null;
  isNewMessage: boolean = false;
  textNewMessage: string;

  constructor(private apiService: IxellAPIService, private tchatService: TchatService, private translate: TranslateService, public sanitizer: DomSanitizer, private router: Router, private headerService: HeaderService, private storage: StorageService, private errorService: ErrorService) { }

  @HostListener('window:message', ['$event'])
  onMessage(ev: MessageEvent) {
    this.changeMessage();
    switch (ev.data) {
      case 'Close':
        this.closeModule();
        break;
      case 'Minimize':
        this.minimizeModule();
        break;
      case 'Restore':
        this.restoreModule();
        break;
      case 'NewMessage':
        if (!this.isNewMessage) {
          this.isNewMessage = true;
          this.startFlashingPageTitle(this.textNewMessage, this.initialTitle);
        }
        break;
    }
  }

  @HostListener('window:focus', ['$event'])
  onFocus(event: any): void {
    if (this.isNewMessage) {
      this.stopFlashingPageTitle();
    }
  }

  ngOnInit() {
    this.langueSub = this.headerService.currentLangue.subscribe(langue => {
      this.langue = langue;
    }, error => {
      console.log(error);
      if (this.langueSub != null) this.langueSub.unsubscribe();
    });

    // Réouverture automatique si conversation en cours
    if (sessionStorage.getItem("urlTchat")) {
      this.urlTchat = sessionStorage.getItem("urlTchat");
      this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.urlTchat);
      if (this.urlTchat.indexOf("&IsMinimized=true") > 0) {
        document.getElementById("iframe-container").classList.remove("iframe-max");
        document.getElementById("iframe-container").classList.add("iframe-min");
      }
    }
  }

  ngOnDestroy() {
    if (this.langueSub != null) this.langueSub.unsubscribe();
  }

  // Modification du message selon la langue
  changeMessage() {
    this.language = this.langue
    this.translate.get('assistance.newMessage').subscribe(data => this.textNewMessage = data);
  }


  closeModule() {
    this.urlSafe = null;
    sessionStorage.removeItem("urlTchat");
    if (this.isNewMessage) {
      this.stopFlashingPageTitle();
    }
  }

  minimizeModule() {
    document.getElementById("iframe-container").classList.remove("iframe-max");
    document.getElementById("iframe-container").classList.add("iframe-min");
    let newUrl = this.urlTchat.replace(this.urlTchat.substring(this.urlTchat.indexOf("&IsMinimized")), "&IsMinimized=true");
    sessionStorage.setItem("urlTchat", newUrl);
  }

  restoreModule() {
    document.getElementById("iframe-container").classList.remove("iframe-min");
    document.getElementById("iframe-container").classList.add("iframe-max");
    let newUrl = this.urlTchat.replace(this.urlTchat.substring(this.urlTchat.indexOf("&IsMinimized")), "&IsMinimized=false");
    sessionStorage.setItem("urlTchat", newUrl);
  }

  startFlashingPageTitle(title: string, initialTitle: string) {
    var b = true;
    this.processTitle = setInterval(function () {
      document.title = (b ? title : initialTitle);
      b = !b;
    }, 500);
  }

  stopFlashingPageTitle() {
    if (this.processTitle != null) {
      clearInterval(this.processTitle);
      this.processTitle = null;
      document.title = this.initialTitle;
    }
      this.isNewMessage = false;
  }
}




